import React from "react";

import ProjectScope from "./projectScope";
import * as Analytics from "../../analytics";
import Config from "./../../config";
import StonesStore from "../../stores/stonesStore";

module.exports = {
  dialog: "reset",
  setSqFt(data) {
    if (data) {
      Analytics.sendDataEnteredEvent("square-foot-calc-data-entered");
      ProjectScope.updateMaterialQuantity(data.squareFeet);
      const featureIds = [];
      const features = {};
      data.backsplashes.forEach(function (backsplash) {
        featureIds.push(backsplash.id);
        features[backsplash.id] = backsplash.length;
      });
      if (featureIds.length > 0) {
        ProjectScope.updateFeaturesQuantities(featureIds, features);
      }
      this.closeSqFtCalc();
    }
  },

  closeSqFtCalc(){
    $('.sqftcalc-window').hide();
    $('.frame_holder').hide();
    $('body').removeClass('fixed').find('.app-container').removeClass('app-container--sqft');
    Analytics.sendClickEvent("hide-sqft-calc");
    // this.setState({sqFtVisible: false});
  },

  showSquareFootCalc(feature) {
    Analytics.sendClickEvent('show-sqft-calc');
    const iframe = $('.sqftcalc-window');
    document.canRunSqft = true;
    if (!ProjectScope.isSqFtCalcLoaded()) {
      // iframe.appendTo($('.scroll_frame')).end().show(); it is already appended
      const nonce = this.getNonce();
      let src = "/content/views/sqftcalc/?_=" + nonce;
      if (location.port === '9007')
      // src = "http://demo.gfd.us" + src;
        src = "/SquareFootCalculator/index.html?_=" + nonce;
      if (Config.kioskStandAlone) { //support for Kiosk StandAlone App
        src = "./../SquareFootCalc/index.html?_=" + nonce;
      }
      src += "&fabricatorId=" +  document.kvConfig.userId;
      
      iframe[0].onload = () => {
        if (iframe[0].contentWindow && iframe[0].contentWindow.setParentCallback) {
          iframe[0].contentWindow.setParentCallback(this, ProjectScope.quote().sFtCalcDataJson);
        }
        window.frames.sqftcalc.document.getElementsByTagName("body")[0].classList.add(`button--${feature}`);
        $('body').addClass('fixed').find('.app-container').addClass('app-container--sqft');
      };
      iframe.attr('src', src).show();
      ProjectScope.setSqFtCalcLoaded(true);
    } else {
      // this.state.sqFtVisible = true;
      iframe.show();
      window.frames.sqftcalc.document.getElementsByTagName("body")[0].classList.add(`button--${feature}`);
      $('body').addClass('fixed').find('.app-container').addClass('app-container--sqft');
      iframe[0].contentWindow.setParentCallback(this, ProjectScope.quote().sFtCalcDataJson || {});
    }
  },

  getNonce(length){
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  },

  setSqFTStep(){
    return 'shapes'
  },

  addAndroidClass(){
    $('.app-container').addClass('app-container--android');
  },

  removeAndroidClass(){
    $('.app-container').removeClass('app-container--android');
  },

  setDataToQt(data = document.settedDataFromCalc, stayOnSqft){

    if (data) {
      StonesStore.setUnsavedChanges();
      let radiuses = [],
        radiusesValues = {};

      Analytics.sendDataEnteredEvent("square-foot-calc-data-entered");
      ProjectScope.updateMaterialQuantity(data.squareFeet);
      if(data.shapesJSON)
        ProjectScope.quote().sFtCalcDataJson = data.shapesJSON;
      const featureIds = [];
      const features = {};
      data.edges.forEach(function (edge) {
        featureIds.push(edge.id);
        features[edge.id] = edge.length;
      });
      data.sinks.forEach(function (sink) {
        featureIds.push(sink.id);
        features[sink.id] = sink.qty;
      });
      const radFeats = StonesStore.featuresByGroupName('Radius', ProjectScope.quote());
      radFeats.forEach(function (value) {
        const name = value.name, range = name.match(/Radius - (?:(\d+|\d+\/\d+)\")(?:-?(\d+)\")?/);

        if (range) {
          if (range[1].indexOf('/') > 0) {
            const fraction = range[1].split('/'), numerator = parseFloat(fraction[0]),
              denominator = parseFloat(fraction[1]);
            range[1] = numerator / denominator;
          }

          const newRange = {min: parseFloat(range[1]), max: parseFloat(range[2])};
          if (isNaN(newRange.max)) {
            newRange.max = newRange.min;
          }

          if (newRange.max > 0) {
            data.radii.forEach(function (radius) {
              const arcLength = parseFloat(radius);
              if (arcLength >= newRange.min && arcLength <= newRange.max) {
                if (featureIds.indexOf(value.id) < 0) {
                  featureIds.push(value.id);
                  features[value.id] = 0;
                  radiuses.push(value.id);
                  radiusesValues[value.id] = 0;
                }
                if (value.unit.toLowerCase().indexOf('each') >= 0) {
                  features[value.id] = features[value.id] + 1;
                  radiusesValues[value.id] = features[value.id] + 1;
                } else {
                  features[value.id] += arcLength;
                  radiusesValues[value.id] += arcLength;
                }
              }
            });
          }
        }
      });

      ProjectScope.updateFeaturesQuantities(featureIds, features, document.settedDataFromCalc);

      document.settedDataFromCalc = data;
      document.settedDataFromCalc.radiuses = radiuses;
      document.settedDataFromCalc.radiusesValues = radiusesValues;

      if (data.canvasImage) {
        const blobBin = atob(data.canvasImage.split(',')[1]);
        const array = [];
        for (let i = 0; i < blobBin.length; i++) {
          array.push(blobBin.charCodeAt(i));
        }

        const fileName = "sqft_calc_diagram_" + ProjectScope.quote().uid + ".png";

        _.each(ProjectScope.documents(), (doc) => {
          if(doc.name == fileName) {
            ProjectScope.deleteDocument(doc);
          }
        });

        if (data.squareFeet > 0) {
          const blob = new Blob([new Uint8Array(array)], {type: 'image/png'});
          // A Blob() is almost a File() - it's just missing the two properties below which we will add
          // http://stackoverflow.com/questions/27159179/how-to-convert-blob-to-file-in-javascript
          blob.lastModifiedDate = new Date();
          blob.name = fileName;
          blob.dataUri = data.canvasImage;
          ProjectScope.addDocument(blob, "Square Foot Calculator Design");
        }
      }

    }

    if (!stayOnSqft) {
      // this.closeSqFtCalc();

      $('.sqftcalc-window').hide();
      $('.frame_holder').hide();
      $('body').removeClass('fixed').find('.app-container').removeClass('app-container--sqft');
      Analytics.sendClickEvent("hide-sqft-calc");
    }

    const iframe = $('.sqftcalc-window');
    if (iframe[0].contentWindow && iframe[0].contentWindow.saveHistory) {
      iframe[0].contentWindow.saveHistory();
    }
  },

  setData(data) {
    if (data !== null) {
      if (data.squareFeet === ProjectScope.quote().material || data.squareFeet === 0) {
        this.setDataToQt(data);
      } else {
        this.dialog = "apply";
        document.settedDataFromCalc = data;
        $('#systemMessageText').html("You are about to update the quantity of materials for your project. Would you like to proceed?");
        $('.confirm-dialog-wrapper').fadeIn();
      }
    }
  },

  callResetDataPopup() {
    this.dialog = "reset";
    $('#systemMessageText').html("Are you sure you would like to cancel all of your unsaved changes?");
    $('.confirm-dialog-wrapper').fadeIn();
  },

  resetData() {
    const iframe = $('.sqftcalc-window');
    if (iframe[0].contentWindow && iframe[0].contentWindow.resetHistory) {
      iframe[0].contentWindow.resetHistory();
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/projectScope/sqftIframe.js